export default "__VITE_ASSET__BWnYi5sp__"